import { z } from "zod";

import { CURRENT_READINESS_CONFIG, READINESS_QUESTION_IDS } from "./config";

/**
 * Which questionnaire produced a funnel event. Derived from the config so a
 * new version splits the analytics series instead of relabelling new answers
 * as the old version's. The browser and the server read this one value.
 */
export const READINESS_FUNNEL_VERSION = `readiness-${CURRENT_READINESS_CONFIG.version}`;

export const READINESS_FUNNEL_CONTEXT = {
  funnel_type: "diagnostic",
  diagnostic_version: READINESS_FUNNEL_VERSION,
} as const;

export const readinessQuestionEventSchema = z
  .object({
    event: z.enum(["diagnose_question_viewed", "diagnose_question_completed"]),
    questionId: z.enum(READINESS_QUESTION_IDS),
  })
  .strict();

export type ReadinessQuestionEvent = z.infer<
  typeof readinessQuestionEventSchema
>;

/** 1-based position in the full questionnaire, stable whatever was skipped. */
export function readinessQuestionNumber(
  questionId: (typeof READINESS_QUESTION_IDS)[number],
): number {
  return READINESS_QUESTION_IDS.indexOf(questionId) + 1;
}
